export enum ApplyWizardStepList {
  personalInfo = 'personalInfo',
  phoneConfirm = 'phoneConfirm',
  experience = 'experience',
  miniInterview = 'miniInterview',
  skill = 'skill',
  language = 'language',
  premiumPromo = 'premiumPromo',
  study = 'study',
  videoInterview = 'videoInterview',
  interview = 'interview', // Backend doesn't have this step, it's the type used for all interview types
}
